import type { FieldErrors } from "react-hook-form";
import type { TextCarouselBannerInput } from "src/features/HomepageCarouselBanners/models";

import { ColorPickerStep } from "src/features/vendorSponsorshipAdmin/components/ColorPickerStep";
import { FormStep } from "src/features/vendorSponsorshipAdmin/components/FormStep";
import LinkPickerStep from "src/components/LinkPicker/LinkPickerStep";
import { RadioStep } from "src/features/vendorSponsorshipAdmin/components/RadioStep";
import { TextInputStep } from "src/features/vendorSponsorshipAdmin/components/TextInputStep";

export interface TextCarouselBannerFormStepListProps {
	onOpenSelectFeedModalClick?: () => void;
	errors?: FieldErrors<TextCarouselBannerInput>;
}

const TextCarouselBannerFormStepList = ({
	errors,
	onOpenSelectFeedModalClick
}: TextCarouselBannerFormStepListProps) => {
	return (
		<ul className="flex flex-col gap-4">
			<li className="w-full">
				<FormStep title="Banner name" error={errors?.name?.message}>
					<TextInputStep
						name="name"
						label="Banner name"
						placeholder="Banner name"
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Select banner background colour"
					error={errors?.backgroundColor?.message}
				>
					<ColorPickerStep name="backgroundColor" />
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Banner text (Optional)"
					error={
						errors?.headingText?.message ||
						errors?.subheadingText?.message ||
						errors?.foregroundColor?.message
					}
				>
					<TextInputStep
						name="headingText"
						label="Heading"
						placeholder="Maximum heading count is 100 characters."
						maxLength={100}
					/>

					<TextInputStep
						name="subheadingText"
						label="Sub heading (optional)"
						placeholder="Maximum sub heading count 34 characters."
						maxLength={34}
					/>

					<ColorPickerStep name="foregroundColor" label="Text colour" />
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Banner link (Optional)"
					error={errors?.linkType?.message}
				>
					<LinkPickerStep
						linkTypeName="linkType"
						urlName="webLink"
						feedName="feed"
						openInBrowserName="openInBrowser"
						label="Link type (optional)"
						helperText="Choose one. Switching options replaces your current selection."
					/>
				</FormStep>
			</li>
		</ul>
	);
};

export default TextCarouselBannerFormStepList;
